import Vue from 'vue';
import VueApollo from 'vue-apollo';
import { createApolloClient, restartWebsockets } from 'vue-cli-plugin-apollo/graphql-client';
import { onError } from 'apollo-link-error';
import { setContext } from 'apollo-link-context';
import { InMemoryCache } from 'apollo-cache-inmemory';
import { socket } from './main'

import { getCookieValue } from './utils';

// Install the vue plugin
Vue.use(VueApollo);

// Http endpoint
const httpEndpoint = process.env.VUE_APP_GRAPHQL_HTTP;
// Files URL root
export const filesRoot =
  process.env.VUE_APP_FILES_ROOT || httpEndpoint.substr(0, httpEndpoint.indexOf('/graphql'));

Vue.prototype.$filesRoot = filesRoot;

const link = onError(({ graphQLErrors, networkError, response, operation }) => {
  if (graphQLErrors) {
    console.log(graphQLErrors)
    for (let e of graphQLErrors) {
      if (!response) response = {}
      response.body = {}
      if (e.message) {
        response.body.message = e.message;
      }
      if (e.extensions && e.extensions.details) {
        response.body.details = e.extensions.details
      }
    }
  }
  response.errors = true;

  // eslint-disable-next-line
  if (networkError) console.log(`[Network error]: ${networkError}`);
});

const authLink = setContext((_, { headers }) => {
  // get the authentication token from local storage if it exists
  const token = getCookieValue('access_token')
  // return the headers to the context so httpLink can read them
  return {
    headers: {
      ...headers,
      Authorization: token ? `Bearer ${token}` : "",
    }
  }
});

const cache = new InMemoryCache({
  dataIdFromObject: object => object._id || object.code || object.name || null
});

const publicClientOptions = {
  httpEndpoint: process.env.VUE_APP_GRAPHQL_PUBLIC_HTTP,
  link: authLink.concat(link),
};

const authClientOptions = {
  httpEndpoint: process.env.VUE_APP_GRAPHQL_HTTP,
  link: authLink.concat(link),
};

// Config
const defaultOptions = {
  wsEndpoint: null, // process.env.VUE_APP_GRAPHQL_WS || 'ws://localhost:3000/graphql',
  persisting: false,
  websocketsOnly: false,
  ssr: false,
  link,
  cache,
};

export const { apolloClient: privateClient } = createApolloClient({
  ...defaultOptions,
  ...authClientOptions,
});
export const { apolloClient: publicClient } = createApolloClient({
  ...defaultOptions,
  ...publicClientOptions,
});

// Call this in the Vue app file
export function createProvider() {
  // Create apollo client

  // apolloClient.wsClient = wsClient

  // Create vue apollo provider
  const apolloProvider = new VueApollo({
    defaultClient: privateClient,
    clients: {
      public: publicClient,
      private: privateClient,
    },
    defaultOptions: {
      $query: {
        fetchPolicy: 'network-only',
      },
    },
    errorHandler(error) {
      // eslint-disable-next-line no-console
      console.log(
        '%cError',
        'background: red; color: white; padding: 2px 4px; border-radius: 3px; font-weight: bold;',
        error.message
      );
    },
  });

  return apolloProvider;
}

// Manually call this when user log in
export async function onLogin(apolloClient, user) {
  this.$store.state.loggedUser = user

  if (apolloClient.wsClient) restartWebsockets(apolloClient.wsClient);

  socket.emit('userLoggedIn', {})
/*   try {
    await apolloClient.resetStore();
  } catch (e) {
    // eslint-disable-next-line no-console
    console.log('%cError on cache reset (login)', 'color: orange;', e.message);
  } */ // when reloading the page, the first graphql query does not work: https://github.com/apollographql/apollo-client/issues/3766
}

// Manually call this when user log out
export async function onLogout(apolloClient) {
  if (process.env.VUE_APP_API_BASE_URL.includes('localhost')) {
    document.cookie = 'access_token=; Max-Age=-99999999; Path=/; Domain=localhost';
  } else {
    document.cookie = 'access_token=; Max-Age=-99999999; Path=/; Domain=.vanderstigel.com';
  }
  
  this.$store.state.loggedUser = {}

  if (apolloClient.wsClient) restartWebsockets(apolloClient.wsClient);
  try {
    await apolloClient.resetStore();
  } catch (e) {
    // eslint-disable-next-line no-console
    console.log('%cError on cache reset (logout)', 'color: orange;', e.message);
  }
}
